module.exports = "https://portperrypedals.ca/_res/img/focus-sept.10ade3a.jpg";